import { HttpClient, HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CommDetailTierRange } from 'src/app/models/commission/comm-detail-tier-range.model';
import { CommPlanDetail } from 'src/app/models/commission/comm-plan-detail.model';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { CommissionService } from 'src/app/service/commission.service';
import { KpimasterService } from 'src/app/service/kpimaster.service';
import { NotificationService } from 'src/app/service/notification.service';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { DatePipe, formatDate } from '@angular/common';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { DepndntKpi } from 'src/app/models/commission/depndnt-kpi.model';
import { DependentScoreKpiModel } from 'src/app/models/commission/dependentscore-kpi.model';
import { GlobalService } from 'src/app/service/global.service';
import { CommissionPlanService } from 'src/app/service/commplan.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EarningPotentialModel } from 'src/app/models/commission/earningpotential.model';

@Component({
  selector: 'app-edit-kpi',
  templateUrl: './edit-kpi.component.html',
  styleUrls: ['./edit-kpi.component.css']
})

export class EditKpiComponent implements OnInit {

  kpiDetailsInsertModel = new CommPlanDetail();
  kpiDetailsInsertModels: CommPlanDetail[] = [];
  kpiDetailsModels: CommPlanDetail[] = [];

  commModel = new CommPlan();
  getAsOfDateData: CommPlan[] = [];

  flags: string[] = ['Y', 'N'];
  kpiDetails: CommPlanDetail[] = [];
  chargebacktypesdata: CommPlanDetail[] = [];
  salesChannelsData: CommPlanDetail[] = [];
  exportExcelkpiDetails: CommPlanDetail[] = [];
  kpiDetailsToReplicate: CommPlanDetail[] = [];
  tierRangeValues: CommDetailTierRange[] = [];
  kpiDetailsData: CommPlanDetail[] = [];
  selectedKpiDetails: CommPlanDetail[] = [];
  selctedCommPlan: CommPlan[] = [];
  kpiDetailsModl = new CommPlanDetail();
  kpiDetailsModlsDup: CommPlanDetail[] = [];

  tierKpiDetailsModels: CommPlanDetail[] = [];

  kpis: Kpimaster[] = [];
  measureTypes: string[] = [];
  allMeasureTypes: string[] = [];
  private readonly commissionRollUpMeasureType = 'Commission Roll Up';
  filteredKpiDetails: Kpimaster[] = [];
  kpiNamesSet = new Set<string>();
  Headder: string = "";
  Orders: any[] = [];
  count: number = 0;
  //commPlan: string = '';
  commData: CommPlan[] = [];
  filterCommData: CommPlan[] = [];
  commDatalength: number = 0;
  @Input() headderText: string;
  isTierRow: boolean = false;
  //commPool: any;
  ordersTableColumns: TableColumn[];
  columnsData: any;
  actions: any;
  ordersTableColumns2: TableColumn[];
  actionButtons: any;
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = '';
  styleClass: string;
  isAddRow: boolean;
  languages: string[];
  countryOptions: { code: string, label: string }[] = [
    { code: 'US', label: 'United States' },
    { code: 'JM', label: 'Jamaica' }
  ];
  dataForExcel = [];
  isShown = false;
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  IsmodelShow: boolean = false;
  payrollCalendar: string[];
  effDt: Date;
  asOfDate: Date = new Date();
  kpiDetailsModlRep = new CommPlanDetail();
  CalendarDtValues: CalendarModel[];

  kpiid: any;
  cid: any;
  comm_plan_dtl_id: any;
  public calTypes: CalendarModel[] = [];

  public measureagainstdata: CommPlanDetail[] = [];
  public measuretypeagainstdata: CommPlanDetail[] = [];
  public calcvarsmeasureagainstdata: CommPlanDetail[] = [];
  public commissionpayoutdata: CommPlanDetail[] = [];

  public depndntScoreKpiModel = new DependentScoreKpiModel();
  public depndntScoreKpiModel1 = new DependentScoreKpiModel();
  public depndntScoreKpiModel2 = new DependentScoreKpiModel();
  public depndntScoreKpiModel3 = new DependentScoreKpiModel();
  public depndntScoreKpiList: DependentScoreKpiModel[] = [];
  public depndntScoreKpiList1: DependentScoreKpiModel[] = [];

  public earningPotentialList1: EarningPotentialModel[] = [];
  public earningPotentialModel3 = new EarningPotentialModel();

  public depndntKpiList: DepndntKpi[];
  public filterKPiData: Kpimaster[] = [];

  public kpiDropdownList: Kpimaster[] = [];

  public isDelete: boolean = true;
  public isCalScoreHide: boolean = false;
  public isCalScoreHideUpdate: boolean = false;
  public isPercentageHide: boolean = true;
  public isMeasureAgainstHide: boolean = true;
  public isPercentageHideUpdate: boolean = true;
  public isRollupHierarchy: boolean = false;

  public isCheckCalScoreHide: boolean = false;
  public isCheckCalcVarHide: boolean = false;
  public isCheckedCalcVars: boolean = false;
  public isCheckedScoreVars: boolean = false;

  public isCheckCalScoreHideUpdate: boolean = false;
  public isCheckCalcVarHideUpdate: boolean = false;
  public isCheckedCalcVarsUpdate: boolean = false;
  public isCheckedScoreVarsUpdate: boolean = false;
  public isPageviewstatus: boolean = false;

  public isCalcVars: boolean = false;
  public isScoreVars: boolean = false;

  public isCalcVarsInsert: boolean = false;
  public isScoreVarsInsert: boolean = false;

  public isCalcChecked: boolean = false;
  public isScoreChecked: boolean = false;
  public showCommPlanImage: boolean = true;
  public orgcomplan: string;
  public pageviewstatus: string;
  public HeadderEp: string;

  public selectedFiles: FileList;
  public currentFile: File;
  public progress = 0;
  public message = '';
  public imgStr: SafeResourceUrl;

  public translateMasterdata: CommPlan[] = [];
  public feedTypeData: CommPlan[] = [];

  constructor(private _sanitizer: DomSanitizer, private commissionPlanService: CommissionPlanService, private globalService: GlobalService,
    private commissionService: CommissionService, private kpimasterService: KpimasterService, private authgurdService: AuthGaurdService, private router: Router, private notificationService: NotificationService,
    private httpService: HttpClient, private exportExcelService: ExportExcelService, private datePipe: DatePipe) { }

  ngOnInit(): void {

    this.HeadderEp = "Edit Earning Potential"

    // added for addrow functionality
    this.depndntScoreKpiModel.created_by = "";
    this.depndntScoreKpiModel.created_dt = new Date();
    this.depndntScoreKpiList.push(this.depndntScoreKpiModel);

    this.depndntScoreKpiModel3.created_by = "";
    this.depndntScoreKpiModel3.created_dt = new Date();
    this.depndntScoreKpiList1.push(this.depndntScoreKpiModel3);

    this.init();
    this.getEarningPotentials();
    this.getAsOfDate();
    this.loadKpis();
    this.getCalTypes();
    this.getKpisList();
    this.getTranslateData();
  }

  public init() {
    this.getChargebackTypes();
    this.getSalesChannelsList();
    this.getMeasureAgainstDropdown();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.resetData();
    this.loadData();
  }

  public loadData() {
    // console.log("loadData() called: "+JSON.stringify(this.commissionService.commModel));

    if (this.commissionService.commModel && !this.commissionService.commModel.editMode) {
      this.commissionService.commModel = JSON.parse(localStorage.getItem("commModel"));
      this.commissionService.salesChannels = JSON.parse(localStorage.getItem("channels"))
    }

    this.orgcomplan = this.commissionService.commModel.comPlan;
    this.pageviewstatus = this.commissionService.commModel.pageviewstatus;

    if (this.pageviewstatus === "View") {
      this.isPageviewstatus = true;
    } else {
      this.isPageviewstatus = false;
    }


    if (this.headderText) {
      this.Headder = this.headderText
      this.commissionService.commModel.commPlan = 'Copy Of ' + this.commissionService.commModel.commPlan;
    } else {
      this.Headder = "Edit Commission Plan"
    }

    this.kpiDetailsModels.push(this.kpiDetailsModl);
    this.commModel = JSON.parse(JSON.stringify(this.commissionService.commModel));

    const dt = new Date(this.commissionService.commModel.effective_date).toISOString().split('T')[0];
    if (this.commModel.status === "getreplicate") {
      this.commModel.effective_date = null;
    } else {
      this.commModel.effective_date = dt;
    }

    this.effDt = JSON.parse(JSON.stringify(this.commissionService.commModel.effective_date))
    // this.salesChannels = this.commissionService.salesChannels;
    this.languages = this.commissionService.languages;

    this.kpiDetails = [];

    this.commissionService.getKpiDetailsForPlan(this.commModel.commPlanId, this.commissionService.commModel.effective_date)
      .subscribe((data: CommPlanDetail[]) => {
        if (this.headderText === "Replicate Commission Plan") {
          this.commModel.effective_date = null;
        }
        this.kpiDetails = data;
        // console.log(JSON.stringify(this.kpiDetails));
        this.kpiDetails = this.kpiDetails.filter((v, i) =>
          this.kpiDetails.findIndex(item => item.kpi_name == v.kpi_name) === i);

        for (let kpiDetail of this.kpiDetails) {
          this.Orders.push(kpiDetail.viewOrder);
          //console.log( kpiDetail.kpi_name);
          if (kpiDetail.display_name === null) {
            kpiDetail.display_name = kpiDetail.kpi_name;
          }
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public resetData() {
    this.commModel = new CommPlan();
    //this.salesChannels = [];
    this.flags = ['Y', 'N'];
    this.kpiDetails = [];
    this.kpiDetailsData = [];
    this.selectedKpiDetails = [];
    this.selctedCommPlan = [];
    this.kpiDetailsModl = new CommPlanDetail();
    this.kpiDetailsInsertModel = new CommPlanDetail();
    this.kpiDetailsModels = [];
    this.tierKpiDetailsModels = [];
    this.isDelete = true;
    this.filteredKpiDetails = [];
    this.Headder = "";
    this.Orders = [];
    this.count = 0;
    this.tierRangeValues = [];
    this.ordersTableColumns2 = [];
    this.languages = [];
    this.payrollCalendar = [];
  }

  /**
   * Keep country in sync with the sales channel on the edit screen, mirroring the add
   * screen (comm-plan). Selecting the Jamaica channel sets country=JM; leaving it resets
   * the JM default back to US so a non-Jamaica plan isn't saved/formatted as JM (HOA-8305).
   */
  public onSalesChannelChange(salesChannelDesc: string): void {
    if (salesChannelDesc === 'Jamaica') {
      this.commModel.country = 'JM';
    } else if (!this.commModel.country || this.commModel.country === 'JM') {
      this.commModel.country = 'US';
    }
  }

  public updateCommissionPlan() {
    // console.log("Inside updateCommissionPlan()");

    if (!this.commModel.comPlan) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Enter Commission Plan");
    } else if (!this.commModel.commPlan) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Enter Commission Plan Description");
    } else if (!this.commModel.calendar_type) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Calendar Type");
    } else if (!this.commModel.effective_date) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Effective Date");
    } else if (!this.commModel.sales_channel_desc) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Sales Channel");
    } else if (!this.commModel.country) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Country");
    } else if (!this.commModel.display_flag) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Show Plan");
    } else if (!this.commModel.charge_back_type) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Chargeback Type");
    } else if (!this.commModel.charge_back) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Select Chargeback");
    } else {

      let prevEffectiveDate = formatDate(this.effDt, 'yyyy-MM-dd', 'en_US');
      let newet = formatDate(this.effDt, 'MM-dd-yyyy', 'en_US');
      let selectedEffectiveDate = formatDate(this.commModel.effective_date, 'yyyy-MM-dd', 'en_US');

      console.log(this.headderText);

      if (prevEffectiveDate === selectedEffectiveDate && this.headderText === "Replicate Commission Plan") {
        console.log("Inside IF");
        this.commModel.edate = newet;
        this.commModel.status = "replicate";
        this.replicateCommissionPlan();
      } else if (prevEffectiveDate === selectedEffectiveDate) {
        console.log("Inside ELSE IF");
        this.commModel.update_dt = new Date();
        this.commModel.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
        this.selctedCommPlan.push(this.commModel);
        this.commissionPlanService.updateCommPlan(this.selctedCommPlan)
          .subscribe(response => {
            if (response) {
              if (this.selectedFiles) {
                this.uploadImages(this.commModel.id);
              }

              this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
              if (this.selctedCommPlan.length === 1) {
                // console.log("Inside IF");
                //console.log(this.selctedCommPlan[0]);
                this.commissionService.commModel = this.selctedCommPlan[0];
              }
              this.init();
            }
            else
              this.notificationService.sendNotification(NotificationType.ERROR, 'Something went wrong');
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          })
      } else {
        console.log("Inside ELSE");
        this.commModel.edate = newet;

        if (this.headderText) {
          this.commModel.status = "replicate";
        } else {
          this.commModel.status = "addcommplan";
        }

        this.replicateCommissionPlan();
      }

    }
  }

  public updateEarningPotentials() {


    this.earningPotentialList1[0].comm_plan_id = this.commModel.commPlanId;
    this.earningPotentialList1[0].effective_date = this.commModel.effective_date;
    this.earningPotentialList1[0].created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.commissionPlanService.updateEp(this.earningPotentialList1)
      .subscribe(response => {
        if (response) {

          // console.log("Inside updateScoreVars ELSE");
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated Successfully`);
          document.getElementById('closeUpdateKPIButton').click();
          this.getEarningPotentials();

        } else {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Something went wrong');
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })

  }





  public addNewRow() {
    const i = this.kpiDetailsModels.length;
    const kpiDetailsMod = new CommPlanDetail();
    if (this.kpiDetailsModl.kpi_name != null) {
      const filterValue = this._normalizeValue(this.kpiDetailsModl.kpi_name);
      this.filteredKpiDetails = this.kpis.filter(kpiF => this._normalizeValue(kpiF.kpi_name).
        includes(filterValue));

      for (let filterrKpi of this.filteredKpiDetails) {

        if (filterrKpi.kpi_name === this.kpiDetailsModl.kpi_name) {
          this.kpiDetailsModels[i - 1].kpi_type = filterrKpi.kpi_type;
          this.kpiDetailsModels[i - 1].kpi_id = filterrKpi.id;
          this.kpiDetailsModels[i - 1].comm_plan_id = this.commModel.commPlanId;
          this.kpiDetailsModels[i - 1].comm_plan = this.commModel.commPlan;
          this.kpiDetailsModels[i - 1].created_dt = new Date();
          this.kpiDetailsModels[i - 1].created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
        }
      }
      this.kpiDetailsModels.push(kpiDetailsMod);
    }
    else
      this.notificationService.sendNotification(NotificationType.ERROR, "Please Seclect KPI Name To Proceed");

  }

  public removeNewRow(index: any) {
    if (this.kpiDetailsInsertModels.length > 1) {
      if (this.kpiDetailsInsertModels[index].rangeLow != null) {
        this.onDeleteNewCommDetailValues(index);
      } else {
        this.onDeleteNewCommDetailValues(index);
        //this.kpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }
  private onDeleteNewCommDetailValues(i: any) {

    if (this.kpiDetailsInsertModels.length > 0) {
      const compos = this.kpiDetailsInsertModels[i].rangeLow;
      this.kpiDetailsInsertModels.forEach((value: any, index: any) => {
        if (value.rangeLow == compos)
          this.kpiDetailsInsertModels.splice(index, 1);
      })
    }
   // console.log(this.kpiDetailsInsertModels);
  }




  public insertNewRow() {
    const i = this.kpiDetailsInsertModels.length;
    const kpiDetailsMod = new CommPlanDetail();



    if (this.kpiDetailsInsertModel.kpi_name != null) {
      const filterValue = this._normalizeValue(this.kpiDetailsInsertModel.kpi_name);
      this.filteredKpiDetails = this.kpis.filter(kpiF => this._normalizeValue(kpiF.kpi_name).includes(filterValue));

      for (let filterrKpi of this.filteredKpiDetails) {

        if (filterrKpi.kpi_name === this.kpiDetailsInsertModel.kpi_name) {
          this.kpiDetailsInsertModels[i - 1].kpi_type = filterrKpi.kpi_type;
          this.kpiDetailsInsertModels[i - 1].kpi_id = filterrKpi.id;
          this.kpiDetailsInsertModels[i - 1].comm_plan_id = this.commModel.commPlanId;
          this.kpiDetailsInsertModels[i - 1].comm_plan = this.commModel.commPlan;
          this.kpiDetailsInsertModels[i - 1].created_dt = new Date();
          this.kpiDetailsInsertModels[i - 1].created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
        }
      }
      this.kpiDetailsInsertModels.push(kpiDetailsMod);
    }
    else {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please Seclect KPI Name To Proceed");
    }

  }

  public removeRow(index: any) {
    if (this.kpiDetailsModels.length > 1) {
      if (this.kpiDetailsModels[index].cdtr_id != 0) {
        this.onDeleteCommDetailValues(this.kpiDetailsModels[index].cdtr_id, index);
      } else
        this.kpiDetailsModels.splice(index, 1);
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "Only one row exists. Try to update.");
    }
  }

  public onDeleteCommDetailValues(id: number, i: number): void {
    if (this.effDt != this.commModel.effective_date) {
    }

    else {
      if (confirm("Are you sure to delete this Record")) {
        this.commissionService.deleteCommDetailValues(id).subscribe(
          (response: CustomHttpRespone) => {
            this.kpiDetailsModels.splice(i, 1);
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          })
      }
    }
  }

  public addKpiToCommPlan(kpiForm: NgForm) {
    // console.log("addKpiToCommPlan() called");

    // console.log(this.kpiDetailsInsertModel);

    let count = 0;
    if (this.kpiDetails?.length > 0) {
      for (let kpiDtl of this.kpiDetails) {
        count = count + 1;
        if (this.kpiDetailsInsertModels[0].viewOrder === kpiDtl.viewOrder) {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter unique order number');
          break;
        }
      }
    }

    if (this.kpiDetailsInsertModels.length == 1) {
      this.insertNewRow();
      this.kpiDetailsInsertModels.pop();
    }

    if (this.kpiDetailsInsertModel.is_calc_vars == null) {
      this.kpiDetailsInsertModels[0].is_calc_vars = false;
    } else {
      this.kpiDetailsInsertModels[0].is_calc_vars = this.kpiDetailsInsertModel.is_calc_vars;
    }

    if (this.kpiDetailsInsertModel.is_score_vars == null) {
      this.kpiDetailsInsertModels[0].is_score_vars = false;
    } else {
      this.kpiDetailsInsertModels[0].is_score_vars = this.kpiDetailsInsertModel.is_score_vars;
    }

    // console.log(this.kpiDetailsInsertModels);

    // CALC VARS
    let calc_id = "NA", calc_kpi_goal = "NA", calc_kpi_id = "NA", calc_kpi_name = "NA", calc_kpi_order = "NA", calc_kpi_weight = "NA", calc_operation = "NA";

    if (this.depndntKpiList.length > 0 && this.kpiDetailsInsertModel.is_calc_vars === true) {
      const appendWithTilde = (arr, key) => arr.map(item => item[key]).join("~");

      calc_id = appendWithTilde(this.depndntKpiList, "id");
      calc_kpi_goal = appendWithTilde(this.depndntKpiList, "kpi_goal");
      calc_kpi_id = appendWithTilde(this.depndntKpiList, "kpi_id");
      calc_kpi_name = appendWithTilde(this.depndntKpiList, "kpi_name");
      calc_kpi_order = appendWithTilde(this.depndntKpiList, "kpi_order");
      calc_kpi_weight = appendWithTilde(this.depndntKpiList, "kpi_weight");
      calc_operation = appendWithTilde(this.depndntKpiList, "operation");
    }

    // SCORE VARS
    let kpiname = "NA", kweight = "NA", created = "NA", kpiids = "NA";

    if (this.depndntScoreKpiList.length > 0 && this.kpiDetailsInsertModel.is_score_vars === true) {

      const kpinameArr = [], kweightArr = [], createdArr = [], kpiidsArr = [];

      const currentUser = localStorage.getItem('CURRENT_USER_NAME_SESSION');

      for (let val of this.depndntScoreKpiList) {

        const filterValue = this.globalService._normalizeValue(val.kpi_name);
        const matchedKpi = this.kpis.find(comm =>
          this.globalService._normalizeValue(comm.kpi_name).startsWith(filterValue)
        );
        const kpiid = matchedKpi ? matchedKpi.id : "0";

        val.id = (val.id === null || val.id === "null") ? 0 : val.id;

        kpinameArr.push(val.kpi_name);
        kweightArr.push(val.kpi_weight);
        kpiidsArr.push(kpiid);
        createdArr.push(currentUser);

      }

      kpiname = kpinameArr.join("~");
      kweight = kweightArr.join("~");
      created = createdArr.join("~");
      kpiids = kpiidsArr.join("~");

    }

    this.kpiDetailsInsertModels.forEach(model => {

      model.display_name = this.kpiDetailsInsertModel.display_name;
      model.display_flg = this.kpiDetailsInsertModel.display_flg;
      model.viewOrder = this.kpiDetailsInsertModel.viewOrder;
      model.kpi_weightage = this.kpiDetailsInsertModel.kpi_weightage;
      model.kpi_goal = this.parseKpiGoal(this.kpiDetailsInsertModel.kpi_goal);
      model.charge_back = this.kpiDetailsInsertModel.charge_back;
      model.calculate_commission = this.kpiDetailsInsertModel.calculate_commission;
      // model.is_pooled = this.kpiDetailsInsertModel.is_pooled;
      model.commission_payout = this.kpiDetailsInsertModel.commission_payout;
      model.roll_up_hierarchy = this.kpiDetailsInsertModel.roll_up_hierarchy;

      model.calc_vars_revenue = this.kpiDetailsInsertModel.calc_vars_revenue;
      model.calc_vars_count = this.kpiDetailsInsertModel.calc_vars_count;
      model.calc_vars_score = this.kpiDetailsInsertModel.calc_vars_score;
      model.calc_vars_row_level = this.kpiDetailsInsertModel.calc_vars_row_level;

      model.id = this.commModel.id;
      model.effective_date = this.commModel.effective_date;

      model.measure_type = this.kpiDetailsInsertModel.measure_type;
      model.measure_against = this.kpiDetailsInsertModel.measure_against;
      model.is_percentage = this.kpiDetailsInsertModel.is_percentage;

      model.calc_id = calc_id;
      model.calc_kpi_goal = calc_kpi_goal;
      model.calc_kpi_id = calc_kpi_id;
      model.calc_kpi_name = calc_kpi_name;
      model.calc_kpi_order = calc_kpi_order;
      model.calc_kpi_weight = calc_kpi_weight;
      model.calc_operation = calc_operation;

      model.calc_updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      model.calc_created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

      model.score_kpiname = kpiname;
      model.score_kweight = kweight;
      model.score_kpiids = kpiids;
      model.score_created = created;
    });

    // console.log(this.kpiDetailsInsertModels);

    this.commissionPlanService.saveKpiDetails(this.kpiDetailsInsertModels)
      .subscribe(response => {
        // console.log(JSON.stringify(response));
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS, `KPI Added Successfully`);

          document.getElementById('closeAddKPIButton').click();
          kpiForm.reset();

          this.kpiDetailsInsertModels = [];
          this.kpiDetailsInsertModel = null;

          this.isCalScoreHide = false;
          this.isCheckCalcVarHide = false;
          this.isCheckCalScoreHide = false;

          // added for addrow functionality
          this.depndntScoreKpiList = [];
          this.depndntScoreKpiModel.created_by = "";
          this.depndntScoreKpiModel.created_dt = new Date();
          this.depndntScoreKpiList.push(this.depndntScoreKpiModel);

        } else {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Something went wrong');
        }
        this.init();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })


  }

  public addfilterMeasureType(event: any) {
    console.log("addfilterMeasureType() called");

    if (event.target.value === "Percentage Modifier by Range" || event.target.value === "Percentage Modifier by Tier" || event.target.value === "Percentage Modifier by Range Per Row") {
      //console.log("Inside IF");
      this.isPercentageHide = true;
      this.isMeasureAgainstHide = true;
      this.isPercentageHideUpdate = true;
    } else if (event.target.value === "No Direct Commission") {
      //console.log("Inside IF");
      this.isPercentageHide = false;
      this.isMeasureAgainstHide = false;
      this.isPercentageHideUpdate = false;
    } else {
      // console.log("Inside ELSE");
      this.isPercentageHide = false;
      this.isMeasureAgainstHide = true;
      this.isPercentageHideUpdate = false;
      this.kpiDetailsInsertModel.is_percentage = null;
    }


    this.ordersTableColumns2 = [];
    this.kpiDetailsInsertModels = [];
    this.kpiDetailsInsertModel.range_high = null;
    this.kpiDetailsInsertModel.rangeLow = null;
    this.kpiDetailsInsertModel.commission_val = null;
    this.kpiDetailsInsertModel.modifier_percent = null;
    this.kpiDetailsInsertModel.tier = null;
    this.kpiDetailsInsertModel.target = null;

    this.kpiDetailsInsertModels.push(this.kpiDetailsInsertModel);
    this.isEnableDisable(event.target.value);
    this.isAddAdtionalRow(event.target.value);
    if (this.ordersTableColumns2.length > 0) {

      if (event.target.value === "Commission Override")
        this.styleClass = 'col-xs-6 col-sm-6 col-lg-6'

      else if (event.target.value === "Flat Commission by Range" || event.target.value === "Flat Commission by Range Per Row" || event.target.value === "Commission Roll Up" || event.target.value === "Flat Commission per Agent" || event.target.value === "Flat Commission" ||
        event.target.value === "Flat Commission by Tier" ||
        event.target.value === "Percentage Modifier by Range" || event.target.value === "Percentage Modifier by Tier" || event.target.value === "Percentage Modifier by Range Per Row")
        this.styleClass = 'col-xs-2 col-sm-2 col-lg-2'

      else {
        const i = 12 / this.ordersTableColumns2.length
        this.styleClass = 'col-xs-' + i + ' col-sm-' + i + ' col-lg-' + i;
      }
    }
  }


  public filterMeasureType(event: any) {
    console.log("filterMeasureType() called");

    if (event.target.value === "Percentage Modifier by Range" || event.target.value === "Percentage Modifier by Tier" || event.target.value === "Percentage Modifier by Range Per Row") {
      // console.log("Inside IF");
      this.isPercentageHide = true;
      this.isMeasureAgainstHide = true;
      this.isPercentageHideUpdate = true;
    }  else if (event.target.value === "No Direct Commission") {
      console.log("Inside IF");
      this.isPercentageHide = false;
      this.isMeasureAgainstHide = false;
      this.isPercentageHideUpdate = false;
    } else {
      // console.log("Inside ELSE");
      this.isPercentageHide = false;
      this.isMeasureAgainstHide = true;
      this.isPercentageHideUpdate = false;
      this.kpiDetailsModl.is_percentage = null;
    }


    this.ordersTableColumns2 = [];
    this.kpiDetailsModels = [];
    this.kpiDetailsModl.range_high = null;
    this.kpiDetailsModl.rangeLow = null;
    this.kpiDetailsModl.commission_val = null;
    this.kpiDetailsModl.modifier_percent = null;
    this.kpiDetailsModl.tier = null;
    this.kpiDetailsModl.target = null;

    this.kpiDetailsModels.push(this.kpiDetailsModl);
    this.isEnableDisable(event.target.value);
    this.isAddAdtionalRow(event.target.value);
    if (this.ordersTableColumns2.length > 0) {

      if (event.target.value === "Commission Override")
        this.styleClass = 'col-xs-6 col-sm-6 col-lg-6'

      else if (event.target.value === "Flat Commission by Range" || event.target.value === "Flat Commission by Range Per Row" || event.target.value === "Commission Roll Up" || event.target.value === "Flat Commission per Agent" || event.target.value === "Flat Commission" ||
        event.target.value === "Flat Commission by Tier" ||
        event.target.value === "Percentage Modifier by Range" || event.target.value === "Percentage Modifier by Tier" || event.target.value === "Percentage Modifier by Range Per Row")
        this.styleClass = 'col-xs-2 col-sm-2 col-lg-2'

      else {
        const i = 12 / this.ordersTableColumns2.length
        this.styleClass = 'col-xs-' + i + ' col-sm-' + i + ' col-lg-' + i;
      }
    }
  }


  public updateKpiDetails(kpiForm: NgForm) {
    // console.log("Inside updateKpiDetails()");
    if (this.pageviewstatus === "View") {
      this.notificationService.sendNotification(NotificationType.ERROR, "Action Disabled");
    } else {

      if (this.effDt != this.commModel.effective_date &&
        (JSON.stringify(this.kpiDetailsModlsDup) != JSON.stringify(this.kpiDetailsModels))) {
      } else {

        let count = 0;
        for (let kpiDtl of this.kpiDetails) {
          count = count + 1;

          if (this.kpiDetailsModl.viewOrder === kpiDtl.viewOrder && this.kpiDetailsModl.kpi_name != kpiDtl.kpi_name) {
            this.notificationService.sendNotification(NotificationType.ERROR, 'Please update with unique order number');
            break;
          } else if (count === this.kpiDetails.length) {
            if (this.kpiDetailsModels.length > 0) {
              for (let kpimodl of this.kpiDetailsModels) {
                kpimodl.kpi_name = this.kpiDetailsModl.kpi_name;
                kpimodl.display_name = this.kpiDetailsModl.display_name;
                kpimodl.viewOrder = this.kpiDetailsModl.viewOrder;
                kpimodl.kpi_weightage = this.kpiDetailsModl.kpi_weightage;
                kpimodl.kpi_goal = this.parseKpiGoal(this.kpiDetailsModl.kpi_goal);
                kpimodl.display_flg = this.kpiDetailsModl.display_flg;
                kpimodl.roll_up_hierarchy = this.kpiDetailsModl.roll_up_hierarchy;
                kpimodl.calculate_commission = this.kpiDetailsModl.calculate_commission;
                kpimodl.update_dt = new Date();
                kpimodl.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
              }
            } else {
              this.kpiDetailsModl.kpi_goal = this.parseKpiGoal(this.kpiDetailsModl.kpi_goal);
              this.kpiDetailsModl.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
              this.kpiDetailsModl.update_dt = new Date();
              this.kpiDetailsModels.push(this.kpiDetailsModl);
            }



            if (this.kpiDetailsModl.is_calc_vars == null) {
              this.kpiDetailsModels[0].is_calc_vars = false;
            } else {
              this.kpiDetailsModels[0].is_calc_vars = this.kpiDetailsModl.is_calc_vars;
            }

            if (this.kpiDetailsModl.is_score_vars == null) {
              this.kpiDetailsModels[0].is_score_vars = false;
            } else {
              this.kpiDetailsModels[0].is_score_vars = this.kpiDetailsModl.is_score_vars;
            }



            this.kpiDetailsModels[0].calc_vars_revenue = this.kpiDetailsModl.calc_vars_revenue;
            this.kpiDetailsModels[0].calc_vars_count = this.kpiDetailsModl.calc_vars_count;
            this.kpiDetailsModels[0].calc_vars_score = this.kpiDetailsModl.calc_vars_score;
            this.kpiDetailsModels[0].calc_vars_row_level = this.kpiDetailsModl.calc_vars_row_level;
            this.kpiDetailsModels[0].commission_payout = this.kpiDetailsModl.commission_payout;
            this.kpiDetailsModels[0].colorcode = this.kpiDetailsModl.colorcode;
            this.kpiDetailsModels[0].measure_type = this.kpiDetailsModl.measure_type;
            this.kpiDetailsModels[0].measure_against = this.kpiDetailsModl.measure_against;
            this.kpiDetailsModels[0].is_percentage = this.kpiDetailsModl.is_percentage;
            this.kpiDetailsModels[0].charge_back = this.kpiDetailsModl.charge_back;
            this.kpiDetailsModels[0].charge_back_days = this.kpiDetailsModl.charge_back_days;
            this.kpiDetailsModels[0].non_charge_back_days = this.kpiDetailsModl.non_charge_back_days;

            // CALC VARS
            let calc_id = "NA", calc_kpi_goal = "NA", calc_kpi_id = "NA", calc_kpi_name = "NA", calc_kpi_order = "NA", calc_kpi_weight = "NA", calc_operation = "NA", calc_updated_by = "NA", calc_created_by = "NA";



            if (this.depndntKpiList.length > 0) {
              const appendWithTilde = (arr, key) => arr.map(item => item[key]).join("~");

              calc_id = appendWithTilde(this.depndntKpiList, "id");
              calc_kpi_goal = appendWithTilde(this.depndntKpiList, "kpi_goal");
              calc_kpi_id = appendWithTilde(this.depndntKpiList, "kpi_id");
              calc_kpi_name = appendWithTilde(this.depndntKpiList, "kpi_name");
              calc_kpi_order = appendWithTilde(this.depndntKpiList, "kpi_order");
              calc_kpi_weight = appendWithTilde(this.depndntKpiList, "kpi_weight");
              calc_operation = appendWithTilde(this.depndntKpiList, "operation");
            }


            // SCORE VARS
            let kpiname = "NA", kweight = "NA", created = "NA", kpiids = "NA";



            if (this.depndntScoreKpiList1.length > 0) {

              const kpinameArr = [], kweightArr = [], createdArr = [], kpiidsArr = [];

              const currentUser = localStorage.getItem('CURRENT_USER_NAME_SESSION');

              for (let val of this.depndntScoreKpiList1) {



                const filterValue = this.globalService._normalizeValue(val.kpi_name);

                const matchedKpi = this.kpis.find(comm =>
                  this.globalService._normalizeValue(comm.kpi_name).startsWith(filterValue)
                );


                const kpiid = matchedKpi ? matchedKpi.id : "0";



                kpinameArr.push(val.kpi_name);
                kweightArr.push(val.kpi_weight);
                kpiidsArr.push(kpiid);
                createdArr.push(currentUser);

              }

              kpiname = kpinameArr.join("~");
              kweight = kweightArr.join("~");
              created = createdArr.join("~");
              kpiids = kpiidsArr.join("~");

            }

            this.kpiDetailsModels.forEach(model => {

              model.calc_id = calc_id;
              model.calc_kpi_goal = calc_kpi_goal;
              model.calc_kpi_id = calc_kpi_id;
              model.calc_kpi_name = calc_kpi_name;
              model.calc_kpi_order = calc_kpi_order;
              model.calc_kpi_weight = calc_kpi_weight;
              model.calc_operation = calc_operation;

              model.calc_updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
              model.calc_created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

              model.score_kpiname = kpiname;
              model.score_kweight = kweight;
              model.score_created = created;
              model.score_kpiids = kpiids;

            });


            console.log(this.kpiDetailsModels);

            this.commissionPlanService.updateKpiDetails(this.kpiDetailsModels)
              .subscribe(response => {
                if (response) {
                  this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated Successfully`);
                  document.getElementById('closeUpdateKPIButton').click();
                  this.init();
                }
                else
                  this.notificationService.sendNotification(NotificationType.ERROR, 'Something Went Wrong');
              }, (errorResponse: HttpErrorResponse) => {
                var msg: any;
                msg = errorResponse;
                this.notificationService.sendNotification(NotificationType.ERROR, msg);
              })
          }
        }
      }
    }
  }

  public deleteKpi() {

    if (this.pageviewstatus === "View") {
      this.notificationService.sendNotification(NotificationType.ERROR, "Action Disabled");
    } else if (this.headderText === "Replicate Commission Plan") {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please Replicate Plan Before Add/Update/Delete");
    } else {
      if (confirm("Are you sure to delete this Record")) {
        this.commissionPlanService.deleteKpiDetails(this.kpiDetailsModl)
          .subscribe((response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);

            this.init();



          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          })
      }
    }

  }



  checkValueCalcvars(event: any) {
    // console.log("checkValueCalcvars() called");
    this.isCheckedCalcVars = event.checked;

    if (this.isCheckedCalcVars === true) {
      this.isCheckCalcVarHide = true;
    } else {
      this.isCheckCalcVarHide = false;

      this.depndntKpiList.forEach((item) => {
        item.kpi_order = null;
        item.operation = null;
        item.kpi_weight = null;
        item.kpi_goal = null;
      });

      this.kpiDetailsModl.calc_vars_score = null;
      this.kpiDetailsModl.calc_vars_revenue = null;
      this.kpiDetailsModl.calc_vars_count = null;
      this.kpiDetailsInsertModel.calc_vars_row_level = 'N';
    }

  }

  checkValueScoreVars(event: any) {
    // console.log("checkValueScoreVars() called");
    this.isCheckedScoreVars = event.checked;

    if (this.isCheckedScoreVars === true) {
      this.isCheckCalScoreHide = true;
    } else {
      this.isCheckCalScoreHide = false;

      this.depndntScoreKpiList.forEach((item) => {
        item.kpi_name = null;
        item.kpi_weight = null;
      });

      this.depndntScoreKpiList = [];
      this.depndntScoreKpiModel.created_by = "";
      this.depndntScoreKpiModel.created_dt = new Date();
      this.depndntScoreKpiList.push(this.depndntScoreKpiModel);

    }
  }

  public getDependentKpiAdd() {
    // console.log("getDependentKpiAdd() called");

    if (this.kpiDetailsInsertModel.kpi_name != null) {
      const filterValue = this._normalizeValue(this.kpiDetailsInsertModel.kpi_name);
      this.filteredKpiDetails = this.kpis.filter(kpiF => this._normalizeValue(kpiF.kpi_name).
        includes(filterValue));
      for (let filterrKpi of this.filteredKpiDetails) {
        if (filterrKpi.kpi_name === this.kpiDetailsInsertModel.kpi_name) {

          this.kpiDetailsInsertModel.kpi_type = filterrKpi.kpi_type;

          if (filterrKpi.kpi_type === "By KPI") {
            this.isCalScoreHide = true;
            this.isCalScoreHideUpdate = true;
            this.isRollupHierarchy = true;
          } else {
            this.isCalScoreHide = false;
            this.isCalScoreHideUpdate = false;
            this.isRollupHierarchy = false;
          }

          this.applyMeasureTypeFilter(filterrKpi.kpi_type);
          this.clearCommissionRollUpIfNotAllowed(this.kpiDetailsInsertModel, filterrKpi.kpi_type);

          this.commissionService.getDepndntKPI(filterrKpi.id, this.kpiDetailsInsertModel.comm_plan_id, 0, this.commModel.effective_date)
            .subscribe((data: DepndntKpi[]) => {
              this.depndntKpiList = data;
              if (this.depndntKpiList.length > 0) {
                this.isShown = true;
              } else {
                this.isShown = false;
              }
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            });

        }
      }
    }
  }

  public getDependentKpi() {
    // console.log("getDependentKpi() called");

    if (this.kpiDetailsModl.kpi_name != null) {
      const filterValue = this._normalizeValue(this.kpiDetailsModl.kpi_name);
      this.filteredKpiDetails = this.kpis.filter(kpiF => this._normalizeValue(kpiF.kpi_name).
        includes(filterValue));
      for (let filterrKpi of this.filteredKpiDetails) {
        if (filterrKpi.kpi_name === this.kpiDetailsModl.kpi_name) {

          this.kpiDetailsModl.kpi_type = filterrKpi.kpi_type;

          if (filterrKpi.kpi_type === "By KPI") {
            this.isCalScoreHide = true;
            this.isCalScoreHideUpdate = true;
            this.isRollupHierarchy = true;
          } else {
            this.isCalScoreHide = false;
            this.isCalScoreHideUpdate = false;
            this.isRollupHierarchy = false;
          }

          this.applyMeasureTypeFilter(filterrKpi.kpi_type);
          this.clearCommissionRollUpIfNotAllowed(this.kpiDetailsModl, filterrKpi.kpi_type);

          this.commissionService.getDepndntKPI(filterrKpi.id, this.kpiDetailsModl.comm_plan_id, 0, this.commModel.effective_date)
            .subscribe((data: DepndntKpi[]) => {
              this.depndntKpiList = data;
              if (this.depndntKpiList.length > 0) {
                this.isShown = true;
              } else {
                this.isShown = false;
              }
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            });

        }
      }
    }
  }























































  getTranslateData() {
    this.kpimasterService.getAdminConfigData()
      .subscribe((data: any) => {
        this.translateMasterdata = data;
        this.getFeedType();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  getFeedType() {
    const filterValue = this.globalService._normalizeValue('EP Key');
    this.feedTypeData = this.translateMasterdata.filter(comm => this.globalService._normalizeValue(comm.trans_field_name).startsWith(filterValue));
    this.feedTypeData = this.feedTypeData.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
  }

  uploadImages(id: any) {
    // console.log("uploadImages() called");
    if (this.selectedFiles === undefined) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Choose image !');
    } else {
      this.progress = 0;
      this.currentFile = this.selectedFiles.item(0);
      this.commissionService.uploadImages(this.currentFile, id).subscribe(
        event => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Image Uploaded Successfully');
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.message = event.body.message;
          }
        }, err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Could not upload the image!');
          this.progress = 0;
          this.message = 'Could not upload the image!';
          this.currentFile = undefined;
        });
      this.selectedFiles = undefined;
    }
  }

  replicateCommissionPlan() {
    // console.log("Inside replicateCommissionPlan()");
    this.commModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.commissionService.replicateCommPlan(this.commModel)
      .subscribe((response: CommPlan) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, `Replicated Successfully`);
        this.init();
        this.router.navigate(['/comm-plan']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  showImage(comm_img: string, img_name: string) {
    // console.log("showImage called");
    this.showCommPlanImage = false;
    this.imgStr = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
      + encodeURI(comm_img));
  }

  hideImage(comm_img: string, img_name: string) {
    // console.log("hideImage called");
    this.showCommPlanImage = true;
  }

  showPdf(comm_img: string, comPlan: string) {
    let pdfWindow = window.open("");
    pdfWindow.document.write("<html<head><title>" + comPlan + "</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:image/png;base64, " + comm_img + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");

  }

  selectedFile(event) {
    // console.log("selectedFile() called");
    this.selectedFiles = event.target.files;
  }

  onChangeAsOfDt() {
    // console.log("onChangeAsOfDt = " + this.commModel.id);
    this.commissionService.getCommPlanByAsOfDt(this.commModel.id)
      .subscribe((data: CommPlan) => {
        this.commissionService.commModel = data;

        localStorage.setItem("commModel", JSON.stringify(this.commissionService.commModel));

        this.init();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }





  checkValueCalcVarsUpdate(event: any) {
    //console.log("checkValueCalcVarsUpdate() called");
    this.isCheckedCalcVarsUpdate = event.checked;

    if (this.isCheckedCalcVarsUpdate === true) {
      this.isCheckCalcVarHideUpdate = true;
    } else {
      this.isCheckCalcVarHideUpdate = false;
      this.kpiDetailsModl.calc_vars_row_level = 'N';
    }

  }

  checkValueScoreVarsUpdate(event: any) {
    // console.log("checkValueScoreVarsUpdate() called");
    this.isCheckedScoreVarsUpdate = event.checked;

    if (this.isCheckedScoreVarsUpdate === true) {
      this.isCheckCalScoreHideUpdate = true;
    } else {
      this.isCheckCalScoreHideUpdate = false;
    }
  }

  addRowScoreVars(kpiForm: NgForm) {
    const kpiObj = new DependentScoreKpiModel();
    kpiObj.kpi_name = this.depndntScoreKpiModel1.kpi_name;
    kpiObj.kpi_weight = this.depndntScoreKpiModel1.kpi_weight;
    this.depndntScoreKpiList.push(kpiObj);
  }
  public removeRowScoreVars(index: any) {


    if (this.depndntScoreKpiList.length > 1) {

      if (this.depndntScoreKpiList[index].kpi_name != null) {
        this.removeByProductFilterData(index);
      } else {
        this.removeByProductFilterData(index);
        this.depndntScoreKpiList.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }

  }
  private removeByProductFilterData(i: any) {
    if (this.depndntScoreKpiList.length > 0) {
      const compos = this.depndntScoreKpiList[i].kpi_name;
      this.depndntScoreKpiList.forEach((value: any, index: any) => {
        if (value.kpi_name == compos)
          this.depndntScoreKpiList.splice(index, 1);
      })
    }
  }

  addByProductUpdateRow(updateKpiForm: NgForm) {
    const kpiObj = new DependentScoreKpiModel();
    kpiObj.kpi_name = this.depndntScoreKpiModel2.kpi_name;
    kpiObj.kpi_weight = this.depndntScoreKpiModel2.kpi_weight;
    this.depndntScoreKpiList1.push(kpiObj);
  }

  public removeByProductUpdateRow(index: any) {
    if (this.depndntScoreKpiList1.length > 1) {
      if (this.depndntScoreKpiList1[index].kpi_name != null) {
        this.removeByProductFilterUpdateData(index);
      } else {
        this.removeByProductFilterUpdateData(index);
        this.depndntScoreKpiList1.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeByProductFilterUpdateData(i: any) {
    if (this.depndntScoreKpiList1.length > 0) {
      const compos = this.depndntScoreKpiList1[i].kpi_name;
      this.depndntScoreKpiList1.forEach((value: any, index: any) => {
        if (value.kpi_name == compos)
          this.depndntScoreKpiList1.splice(index, 1);
      })
    }
  }

  addByEPUpdateRow(updateKpiForm: NgForm) {
    const epObj = new EarningPotentialModel();
    epObj.key_id = this.earningPotentialModel3.key_id;
    epObj.key_value = this.earningPotentialModel3.key_value;
    this.earningPotentialList1.push(epObj);
  }

  public removeByEPUpdateRow(index: any) {
    if (this.earningPotentialList1.length > 1) {
      if (this.earningPotentialList1[index].key_value != null) {
        this.removeByEPFilterUpdateData(index);
      } else {
        this.removeByEPFilterUpdateData(index);
        this.earningPotentialList1.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeByEPFilterUpdateData(i: any) {
    if (this.earningPotentialList1.length > 0) {
      const compos = this.earningPotentialList1[i].key_value;
      this.earningPotentialList1.forEach((value: any, index: any) => {
        if (value.key_value == compos)
          this.earningPotentialList1.splice(index, 1);
      })
    }
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelKpiDetails;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }


  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }



  public getChargebackTypes(): void {
    this.commissionService.getChargebackTypes().subscribe(
      (response: CommPlanDetail[]) => {
        this.chargebacktypesdata = response;
        this.chargebacktypesdata = this.chargebacktypesdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getSalesChannelsList(): void {
    this.commissionService.getSalesChannelsList().subscribe(
      (response: CommPlanDetail[]) => {
        this.salesChannelsData = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }



  findTierRangeValues(row: any) {
    this.commissionService.getTierRangeValues(row.row.id)
      .subscribe((data: any) => {
        this.tierRangeValues = [];
        this.tierRangeValues = data;
        this.setValues(row)
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public redirect(url: string) {

    if (url === 'kpi-master')
      this.router.navigate(['/' + url], { queryParams: { page: 'replicate-plan' } });
    else
      this.router.navigate(['/' + url]);
  }

  public editPlan() {

    for (let kpiDetail of this.kpiDetails) {
    }
  }



  getAsOfDate() {
    this.commissionService.getAsOfDate(this.commModel.commPlanId)
      .subscribe((data: CommPlan | CommPlan[]) => {
        this.getAsOfDateData = Array.isArray(data) ? data : (data ? [data] : []);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getEarningPotentials() {
    this.commissionService.getEarningPotentials(this.commModel.commPlanId, this.commModel.effective_date)
      .subscribe((response: EarningPotentialModel[]) => {
        if (response.length > 0) {
          this.earningPotentialList1 = response;
        } else {
          this.earningPotentialModel3.created_by = "";
          this.earningPotentialModel3.created_dt = new Date();
          this.earningPotentialList1.push(this.earningPotentialModel3);
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }







  public selectedKpi(kpiDetail: CommPlanDetail, values: any) {
    if (values.currentTarget.checked) {
      this.selectedKpiDetails.push(kpiDetail);
    } else {
      this.selectedKpiDetails.forEach((value: any, index: any) => {
        if (value.id === kpiDetail.comm_plan_dtl_id) this.selectedKpiDetails.splice(index, 1);
      });
    }
    if (this.selectedKpiDetails.length > 0) {
      this.isDelete = false;
    }
    else {
      this.isDelete = true;
    }
  }



  private validateEffictiveDt() {
    this.commissionService.validateEffictiveDt(this.commModel.commPlanId)
      .subscribe((response: CalendarModel[]) => {
        this.CalendarDtValues = response;
        if (this.CalendarDtValues.length > 0) {
          for (let calDt of this.CalendarDtValues) {
            if (new Date(calDt.valid_from_dt).getTime() <= this.commModel.effective_date.getTime() &&
              new Date(calDt.valid_to_dt).getTime() >= this.commModel.effective_date.getTime()) {
              this.notificationService.notify(NotificationType.WARNING, "For The Selected EffictiveDate The Calculation Has Done.");
              break;
            }
          }
        } else {
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  getMeasureAgainstDropdown() {
    this.commissionService.getMeasureAgainstDropdown()
      .subscribe((data: any) => {

        this.measureagainstdata = data;
        this.measuretypeagainstdata = data;
        this.calcvarsmeasureagainstdata = data;
        this.commissionpayoutdata = data;

        const filterValue = this.globalService._normalizeValue('Measure Against');
        this.measureagainstdata = this.measureagainstdata.filter(item => this.globalService._normalizeValue(item.trans_field_name).startsWith(filterValue));
        this.measureagainstdata = this.measureagainstdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);

        const filterValue1 = this.globalService._normalizeValue('Calc Vars Measure Against');
        this.calcvarsmeasureagainstdata = this.calcvarsmeasureagainstdata.filter(item => this.globalService._normalizeValue(item.trans_field_name).startsWith(filterValue1));
        this.calcvarsmeasureagainstdata = this.calcvarsmeasureagainstdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);

        const filterValue2 = this.globalService._normalizeValue('Commission Payout');
        this.commissionpayoutdata = this.commissionpayoutdata.filter(item => this.globalService._normalizeValue(item.trans_field_name).startsWith(filterValue2));
        this.commissionpayoutdata = this.commissionpayoutdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);

        const filterValue3 = this.globalService._normalizeValue('Measure Type Against');
        this.measuretypeagainstdata = this.measuretypeagainstdata.filter(item => this.globalService._normalizeValue(item.trans_field_name).startsWith(filterValue3));
        this.measuretypeagainstdata = this.measuretypeagainstdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);


      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getCalTypes() {
    this.commissionService.getCalTypes()
      .subscribe((data: any) => {
        this.calTypes = data;
        const filterValue = this.globalService._normalizeValue('Active');
        this.calTypes = this.calTypes.filter(cal => this.globalService._normalizeValue(cal.active_flag).startsWith(filterValue));
        //this.measureagainstdata = this.measureagainstdata.sort((a, b) => (a.trans_field_value < b.trans_field_value) ? -1 : 1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }




  public getKpisList() {
    this.kpimasterService.getDependentKpis()
      .subscribe((response: any) => {
        this.kpiDropdownList = response;
        for (let kpi of this.kpiDropdownList) {
          this.kpiNamesSet.add(kpi.kpi_name);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }







  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }



  public loadKpis() {
    this.kpimasterService.getActiveKpis()
      .subscribe((data: Kpimaster[]) => {
        this.kpis = data;
        const filterValue = this.globalService._normalizeValue('Active');
        this.filterKPiData = this.kpis.filter(comm => this.globalService._normalizeValue(comm.kpi_status).startsWith(filterValue));
        this.getMeasureTypes();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  public deleteCalcVar(index: any) {

    if (confirm("Are you sure to delete this Record")) {
      this.commissionService.deleteCalvars(this.depndntKpiList[index].id).subscribe(
        (response: CustomHttpRespone) => {
          this.getDepndntKPI(this.kpiid, this.cid, this.comm_plan_dtl_id);
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    }
  }




  public isEnableDisable(measureType: string, row?: any) {
    this.ordersTableColumns2 = [];
    if (measureType === 'Percentage Modifier by Tier') {
      this.ordersTableColumns2 = [{
        "name": "Range From",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Range To",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Tier",
        "dataKey": "tier",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "text"
      },
      {
        "name": "Modifier%",
        "dataKey": "modifier_percent",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }


      ]

    } else if (measureType === 'Flat Commission by Tier') {
      this.ordersTableColumns2 = [{
        "name": "Range From",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Range To",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },

      {
        "name": "Tier",
        "dataKey": "tier",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "text"
      },
      {
        "name": "Comm Value",
        "dataKey": "commission_val",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }

      ]

    } else if (measureType === 'Percentage Modifier by Range') {
      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [{
        "name": "Range From",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Range To",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Modifier%",
        "dataKey": "modifier_percent",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }]

      } else if (measureType === 'Percentage Modifier by Range Per Row') {
      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [{
        "name": "Range From",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Range To",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Modifier%",
        "dataKey": "modifier_percent",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }]

    } else if (measureType === 'Flat Commission by Range' || measureType === 'Flat Commission by Range Per Row' || measureType === "Commission Roll Up" || measureType === 'Flat Commission per Agent' || measureType === "Flat Commission") {
      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [{
        "name": "Range From",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Range To",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Comm Value",
        "dataKey": "commission_val",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }]

    }
    else if (measureType === 'Flat Commission for a Target') {

      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [
        {
          "name": "Target",
          "dataKey": "target",
          "position": "left",
          "isSortable": true,
          "edit": false,
          "type": "number"
        },
        {
          "name": "Comm Value",
          "dataKey": "commission_val",
          "position": "left",
          "isSortable": true,
          "edit": false,
          "type": "number"
        }]
    }
    else if (measureType === 'Percentage Modifier for a Target') {

      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [{
        "name": "Target",
        "dataKey": "target",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Modifier%",
        "dataKey": "modifier_percent",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }]
    }
    else if (measureType === 'Bonus') {
      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [
        {
          "name": "Comm Value",
          "dataKey": "commission_val",
          "position": "left",
          "isSortable": true,
          "edit": false,
          "type": "number"
        }]
    }
    else if (measureType === 'Commission Override') {
      this.ordersTableColumns2 = [];
      this.ordersTableColumns2 = [{
        "name": "Range From",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Range To",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Comm Value",
        "dataKey": "commission_val",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Modifier%",
        "dataKey": "modifier_percent",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      },
      {
        "name": "Tier",
        "dataKey": "tier",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "text"
      },
      {
        "name": "Target",
        "dataKey": "target",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }]
    }

    if (row && this.ordersTableColumns2.length > 0) {
      this.findTierRangeValues(row);
    } else if (row) {
      this.tierRangeValues = [];
      this.setValues(row);
    }

  }

  /** Keep decimals when KPI Goal is typed as text (e.g. 5.9). */
  parseKpiGoal(value: any): number {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const n = parseFloat(String(value));
    return isNaN(n) ? null : n;
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  keyPressNumbersOnRange(event, type: any) {
    if (type === 'number') {
      var charCode = (event.which) ? event.which : event.keyCode;
      if (charCode != 46 && charCode > 31 && charCode != 45
        && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    }
    else {
      return true;
    }
  }

  private getMeasureTypes() {
    this.commissionService.getMeasureTypes()
      .subscribe((data: any) => {
        this.allMeasureTypes = (Array.isArray(data) ? data : []).sort((a, b) => (a < b) ? -1 : 1);
        this.applyMeasureTypeFilter(this.getActiveKpiType());
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private getActiveKpiType(): string | null {
    if (this.kpiDetailsModl?.kpi_type) {
      return this.kpiDetailsModl.kpi_type;
    }
    if (this.kpiDetailsInsertModel?.kpi_type) {
      return this.kpiDetailsInsertModel.kpi_type;
    }
    return this.getKpiTypeForSelectedKpi(this.kpiDetailsInsertModel?.kpi_name);
  }

  private getKpiTypeForSelectedKpi(kpiName?: string): string | null {
    if (!kpiName) {
      return null;
    }
    const selectedKpi = this.kpis.find(kpi => kpi.kpi_name === kpiName);
    return selectedKpi?.kpi_type ?? null;
  }

  private applyMeasureTypeFilter(kpiType?: string | null): void {
    const allowCommissionRollUp = kpiType === 'By KPI';
    const source = this.allMeasureTypes.length ? this.allMeasureTypes : (this.measureTypes as string[]);
    this.measureTypes = source.filter(
      measureType => allowCommissionRollUp || measureType !== this.commissionRollUpMeasureType
    );
  }

  private clearCommissionRollUpIfNotAllowed(model: CommPlanDetail, kpiType?: string | null): void {
    if (kpiType === 'By KPI' || model?.measure_type !== this.commissionRollUpMeasureType) {
      return;
    }
    model.measure_type = null;
    this.ordersTableColumns2 = [];
  }

  reloadPage() {
    this.init();
  }

  closeAdd(kpiForm: NgForm, id: string) {
    //console.log("closeAdd() called");

    this.IsmodelShow = true;
    kpiForm.reset();
    // HOA-8330: the row-level checkbox is one-way bound ([checked]/(change)), so kpiForm.reset()
    // does not clear it. Explicitly reset the flag so a stale 'Y' from an abandoned Add can't be
    // silently re-saved when the Add modal is reopened.
    if (this.kpiDetailsInsertModel) {
      this.kpiDetailsInsertModel.calc_vars_row_level = 'N';
    }
    this.ordersTableColumns2 = [];
    document.getElementById(id).click();
  }
  closeUpdate(kpiForm: NgForm, id: string) {
    //console.log("closeUpdate() called");

    this.IsmodelShow = true;
    kpiForm.reset();
    this.ordersTableColumns2 = [];
    document.getElementById(id).click();
  }

  actionOnButton(action: any) {
    if (this.headderText === "Replicate Commission Plan") {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please Replicate Plan Before Add/Update/Delete");
    } else {
      this.IsmodelShow = false;
      this.ordersTableColumns2 = [];
      this.depndntKpiList = [];
      document.getElementById(action).click();
    }
  }

  check(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  isTier(tier: string): boolean {
    if (tier === 'Tier')
      return true;
    else
      return false;
  }

  isAddAdtionalRow(measureType: string) {
    if (measureType === 'Percentage Modifier by Tier' || measureType ===
      'Flat Commission by Tier' || measureType === 'Percentage Modifier by Range' || measureType === 'Percentage Modifier by Range Per Row' ||
      measureType === 'Flat Commission by Range' || measureType === 'Flat Commission by Range Per Row' || measureType === "Commission Roll Up" || measureType === 'Flat Commission per Agent' || measureType === 'Flat Commission') {
      this.isAddRow = true;
    }
    else {
      this.isAddRow = false;
    }
  }
  public getDepndntKPI(kpi_id: any, commPlanId: any, comm_plan_dtl_id: number) {
    this.commissionService.getDepndntKPI(kpi_id, commPlanId, comm_plan_dtl_id, this.commModel.effective_date)
      .subscribe((data: DepndntKpi[]) => {
        this.depndntKpiList = data;
        if (this.depndntKpiList.length > 0) {

          if (this.depndntKpiList[0].is_calc_vars === "true") {
            this.kpiDetailsModl.is_calc_vars = true;
            this.isCheckCalcVarHideUpdate = true;
          } else {
            this.kpiDetailsModl.is_calc_vars = false;
            this.isCheckCalcVarHideUpdate = false;
          }
        } else {
          this.isCheckCalcVarHideUpdate = false;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getDependentScoreKpi(complexkpiid: number, comp_plan_id: number, comm_plan_dtl_id: any) {
    this.commissionService.getDepndntScoreKPI(complexkpiid, comp_plan_id, comm_plan_dtl_id, this.commModel.effective_date)
      .subscribe((data: DependentScoreKpiModel[]) => {
        this.depndntScoreKpiList1 = data;
        if (this.depndntScoreKpiList1.length === 0) {
          this.depndntScoreKpiModel3.created_by = "";
          this.depndntScoreKpiModel3.created_dt = new Date();
          this.depndntScoreKpiList1.push(this.depndntScoreKpiModel3);
        }
        if (this.depndntScoreKpiList1[0].is_score_vars === "true") {
          this.kpiDetailsModl.is_score_vars = true;
          this.isCheckCalScoreHideUpdate = true;
        } else {
          this.kpiDetailsModl.is_score_vars = false;
          this.isCheckCalScoreHideUpdate = false;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  setValues(row: any) {
    if (row.value === 'Update') {
      this.depndntKpiList = [];
      this.isAddAdtionalRow(row.row.measure_type);
      this.kpiDetailsModels = [];

      if (row.row.kpi_type === "By KPI") {
        this.isCalScoreHideUpdate = true;
        this.isRollupHierarchy = true;
      } else {
        this.isCalScoreHideUpdate = false;
        this.isRollupHierarchy = false;
      }

      this.applyMeasureTypeFilter(row.row.kpi_type);

      this.kpiid = row.row.kpi_id;
      this.cid = row.row.commPlanId;
      this.comm_plan_dtl_id = row.row.id;
      this.getDepndntKPI(this.kpiid, this.cid, this.comm_plan_dtl_id);

      if (this.tierRangeValues.length > 0) {
        for (let tierRangeData of this.tierRangeValues) {

          this.kpiDetailsModl = new CommPlanDetail();
          this.kpiDetailsModl.kpi_id = row.row.kpi_id;
          this.kpiDetailsModl.comm_plan_dtl_id = row.row.id;
          this.kpiDetailsModl.comm_plan_id = row.row.commPlanId;
          this.kpiDetailsModl.kpi_name = row.row.kpi_name;
          this.kpiDetailsModl.kpi_type = row.row.kpi_type;
          this.kpiDetailsModl.kpi_weightage = row.row.kpi_weightage;
          this.kpiDetailsModl.colorcode = row.row.colorcode;
          this.kpiDetailsModl.kpi_goal = row.row.kpi_goal;
          this.kpiDetailsModl.display_flg = row.row.display_flg;
          this.kpiDetailsModl.roll_up_hierarchy = row.row.roll_up_hierarchy;
          this.kpiDetailsModl.measure_type = row.row.measure_type;
          this.kpiDetailsModl.viewOrder = row.row.viewOrder;
          this.kpiDetailsModl.display_name = row.row.display_name;
          this.kpiDetailsModl.cdtr_id = tierRangeData.id;
          this.kpiDetailsModl.rangeLow = tierRangeData.rangeLow;
          this.kpiDetailsModl.range_high = tierRangeData.range_high;
          this.kpiDetailsModl.tier = tierRangeData.tier;
          this.kpiDetailsModl.target = tierRangeData.target;
          this.kpiDetailsModl.modifier_percent = tierRangeData.modifier_percent;
          this.kpiDetailsModl.commission_val = tierRangeData.commission_val;
          this.kpiDetailsModl.charge_back = row.row.charge_back;
          this.kpiDetailsModl.charge_back_days = row.row.charge_back_days;
          this.kpiDetailsModl.non_charge_back_days = row.row.non_charge_back_days;

          this.kpiDetailsModl.measure_against = row.row.measure_against;
          this.kpiDetailsModl.calculate_commission = row.row.calculate_commission;
          this.kpiDetailsModl.is_percentage = row.row.is_percentage;
          // this.kpiDetailsModl.is_pooled = row.row.is_pooled;

          this.kpiDetailsModl.is_calc_vars = row.row.is_calc_vars;
          this.kpiDetailsModl.is_score_vars = row.row.is_score_vars;
          this.kpiDetailsModl.commission_payout = row.row.commission_payout;
          this.kpiDetailsModl.calc_vars_revenue = row.row.calc_vars_revenue;
          this.kpiDetailsModl.calc_vars_count = row.row.calc_vars_count;
          this.kpiDetailsModl.calc_vars_score = row.row.calc_vars_score;
          this.kpiDetailsModl.calc_vars_row_level = row.row.calc_vars_row_level;


          this.kpiDetailsModels.push(this.kpiDetailsModl);
          this.kpiDetailsModlsDup = JSON.parse(JSON.stringify(this.kpiDetailsModels));
        }
      }
      else {
        this.kpiDetailsModl.kpi_id = row.row.kpi_id;

        this.kpiDetailsModl.comm_plan_dtl_id = row.row.id;
        this.kpiDetailsModl.comm_plan_id = row.row.commPlanId;
        this.kpiDetailsModl.kpi_name = row.row.kpi_name;
        this.kpiDetailsModl.kpi_type = row.row.kpi_type;
        this.kpiDetailsModl.kpi_weightage = row.row.kpi_weightage;
        this.kpiDetailsModl.kpi_goal = row.row.kpi_goal;
        this.kpiDetailsModl.display_flg = row.row.display_flg;
        this.kpiDetailsModl.roll_up_hierarchy = row.row.roll_up_hierarchy;
        this.kpiDetailsModl.measure_type = row.row.measure_type;
        this.kpiDetailsModl.viewOrder = row.row.viewOrder;
        this.kpiDetailsModl.display_name = row.row.display_name;

        this.kpiDetailsModl.measure_against = row.row.measure_against;
        this.kpiDetailsModl.calculate_commission = row.row.calculate_commission;
        this.kpiDetailsModl.is_percentage = row.row.is_percentage;

        // this.kpiDetailsModl.is_pooled = row.row.is_pooled;

        this.kpiDetailsModl.charge_back = row.row.charge_back;
        this.kpiDetailsModl.charge_back_days = row.row.charge_back_days;
        this.kpiDetailsModl.non_charge_back_days = row.row.non_charge_back_days;

        this.kpiDetailsModl.is_calc_vars = row.row.is_calc_vars;
        this.kpiDetailsModl.is_score_vars = row.row.is_score_vars;
        this.kpiDetailsModl.commission_payout = row.row.commission_payout;
        this.kpiDetailsModl.calc_vars_revenue = row.row.calc_vars_revenue;
        this.kpiDetailsModl.calc_vars_count = row.row.calc_vars_count;
        this.kpiDetailsModl.calc_vars_score = row.row.calc_vars_score;
        this.kpiDetailsModl.calc_vars_row_level = row.row.calc_vars_row_level;
      }

      this.clearCommissionRollUpIfNotAllowed(this.kpiDetailsModl, row.row.kpi_type);

      if (row.row.measure_type === "Commission Override")
        this.styleClass = 'col-xs-6 col-sm-6 col-lg-6'

      else if (row.row.measure_type === "Flat Commission by Range" || row.row.measure_type === "Flat Commission by Range Per Row" || row.row.measure_type === "Commission Roll Up" || row.row.measure_type === 'Flat Commission per Agent' || row.row.measure_type === 'Flat Commission' ||
        row.row.measure_type === "Flat Commission by Tier" ||
        row.row.measure_type === "Percentage Modifier by Range" ||
        row.row.measure_type === "Percentage Modifier by Tier" ||
       row.row.measure_type === "Percentage Modifier by Range Per Row")
        this.styleClass = 'col-xs-2 col-sm-2 col-lg-2'

      else {
        const i = 12 / this.ordersTableColumns2.length
        this.styleClass = 'col-xs-' + i + ' col-sm-' + i + ' col-lg-' + i;
      }
      document.getElementById('Update KPI').click();
    }
    if (row.value === 'Delete') {
      this.kpiDetailsModl = row.row;
      this.kpiDetailsModl.comm_plan_dtl_id = row.row.id;
      this.kpiDetailsModl.comm_plan_id = row.row.commPlanId;

      this.deleteKpi();
    }
  }

  /**
   * True when calc-vars is enabled. is_calc_vars can arrive as a real boolean OR
   * as the string "true"/"false" (depending on the load path), so the string
   * "false" must be treated as false — otherwise !is_calc_vars is false for
   * "false" and the row-level checkbox is wrongly left enabled (HOA-8330 review).
   */
  public isCalcVarsEnabled(value: any): boolean {
    return value === true || value === 'true';
  }

  public exportExcel() {

    this.exportExcelkpiDetails = JSON.parse(JSON.stringify(this.kpiDetails));
    for (let js of this.exportExcelkpiDetails) {
      delete js.id;
      delete js.commPlanId;
      delete js.cdtr_id;
      delete js.comm_plan_id;
      delete js.comm_plan_dtl_id;
      delete js.created_dt;
      delete js.created_by;
      delete js.update_dt;
      delete js.updated_by;
      delete js.effective_date;
      delete js.comm_plan;
      delete js.comm_pool;
      delete js.commission_val;
      delete js.kpi_goal;
      delete js.modifier_percent;
      delete js.rangeLow;
      delete js.range_high;
      delete js.target;
      delete js.tier;
      delete js.charge_back_days;
      delete js.non_charge_back_days;
      delete js.calc_vars_count;
      delete js.calc_vars_revenue;
      delete js.calc_vars_score;
      delete js.calculate_commission;
      delete js.colorcode;
      delete js.comm_img_str;
      delete js.is_calc_vars;
      delete js.calc_vars_row_level;
      delete js.is_percentage;
      // delete js.is_pooled;
      delete js.is_score_vars;
      delete js.trans_field_name;
      delete js.trans_field_value;
      delete js.commplan_rowid;
      delete js.kpi_weightage;
      delete js.roll_up_hierarchy;

    }
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelkpiDetails.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'KPI Details',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  rowAction(row: any) {
    this.kpiDetailsModlRep = row.row;
    if (this.headderText === "Replicate Commission Plan") {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please Replicate Plan Before Add/Update/Delete");
    } else {
      if (row.value === 'Update' || row.value === 'View') {
        this.kpiDetailsModl.is_calc_vars = null;
        this.kpiDetailsModl.is_score_vars = null;

        this.IsmodelShow = false;

        if (row.row.is_calc_vars === "true") {
          this.isCheckCalcVarHideUpdate = true;
          this.isCalcChecked = true;
          this.kpiDetailsModl.is_calc_vars = true;
        } else {
          this.isCheckCalcVarHideUpdate = false;
          this.isCalcChecked = false;
          this.kpiDetailsModl.is_calc_vars = false;
        }

        if (row.row.is_score_vars === "true") {
          this.isCheckCalScoreHideUpdate = true;
          this.isScoreChecked = true;
        } else {
          this.isCheckCalScoreHideUpdate = false;
          this.isScoreChecked = false;
        }


        if (row.row.measure_type === "Percentage Modifier by Range" || row.row.measure_type === "Percentage Modifier by Tier" || row.row.measure_type === "Percentage Modifier by Range Per Row") {
          this.isPercentageHideUpdate = true;
        } else {
          this.isPercentageHideUpdate = false;
        }

        this.isEnableDisable(row.row.measure_type, row);
        this.getDependentScoreKpi(row.row.kpi_id, row.row.commPlanId, row.row.id);
      } else {
        this.setValues(row);
      }
    }
  }

  innerRowAction(row: any) {
    if (row.value === 'Delete') {
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.KpiDetails;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    this.actions = [
      {
        name: 'Update',
        dataKey: 'fas fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'fas fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }

    ],
      this.actionButtons = [

        {
          name: 'Add KPI',
          class: 'btn btn-primary btn-xs addkpibutton',
        }
      ]
  }

  isLastDayOfMonth(date: Date | null): boolean {
    date = date ?? new Date();
    const dayOfMonth = date.getDate();
    const lastDayOfMonth = getLastDayOfMonth(date);

    return dayOfMonth === lastDayOfMonth;
  };

}

function getLastDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDate();
}
